import React, { useState } from 'react';

import Tippy from '@tippyjs/react';

import { ia } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

import PayerAltNamesModal from './PayerAltNamesModal';

const PayerNameWithInfo = ({ payer }) => {
  const altNames = payer?.payerAltNames || [];
  const hasAltNames = ia(altNames);
  const status = payer?.status; // 'pending' is for pending approval
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleIconClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (hasAltNames && status !== 'pending') {
      setIsModalOpen(true);
    }
  };

  const tippyContent =
    status === 'pending'
      ? 'Pending approval'
      : hasAltNames
        ? 'Click to see all other known names for this payer'
        : 'This payer has no other known names';

  return (
    <>
      <div className="flex items-center gap-2">
        <div className="max-h-[22px] cursor-pointer rounded-sm hover:bg-neutral-75">
          <Tippy
            interactive
            content={tippyContent}
            className="tippy-dark arrow-small"
            appendTo={document.body}>
            <div
              className={`flex transition ${hasAltNames ? 'cursor-pointer hover:bg-neutral-75' : ''}`}
              data-payer-info-icon
              onClick={handleIconClick}>
              <Icon
                icon="info-mono"
                size={16}
                color={status === 'pending' ? 'warning' : 'neutral'}
                shade={600}
              />
            </div>
          </Tippy>
        </div>

        <span>{payer?.name || '-'}</span>
      </div>

      <PayerAltNamesModal
        isOpen={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        altNames={altNames}
      />
    </>
  );
};

export default PayerNameWithInfo;
